<template>
  <div class="order-list">
    <h1 class="title">我的订单</h1>
    <div class="order-container">
      <div class="order-item" v-for="order in orders" :key="order.id">
        <div class="order-header">
          <span class="order-id">订单号: {{ order.orderNumber }}</span>
          <span class="order-status">{{ order.statusName }}</span>
        </div>
        <div class="order-details">
          <div class="order-product" v-for="product in order.ordersInfoList" :key="product.id">
            <img :src="product.houseImageUrl" alt="Product Image" class="product-image"/>
            <div class="product-info">
              <div class="div-count">
                <span class="product-name">{{ product.houseName }}</span>
                <span class="product-price">¥{{ product.housePrice }}</span>
              </div>

              <div class="div-count">
                <span class="product-fenlei">一层别墅</span>
              <span class="product-count">x2</span>
              </div>
              
  
            
            </div>
          </div>
        </div>
        <div class="order-footer">
          <button class="btn">查看详情</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref,getCurrentInstance,onMounted } from 'vue';

export default {
  setup() {

    const { proxy } = getCurrentInstance();

    const orders = ref([
      
    ]);


    const queryOrder = async() =>{
      const url = '/house/queryOrder';
      proxy.$tools.request(url,{reqBody:{}}).then(response => {
        orders.value=response.data.rspBody.orderList;
      })
      .catch(error =>{
        console.error(error)
      });
    };

    onMounted(() => {
      queryOrder();
    }); 

    return {
      orders,
      queryOrder
    };
  },
};
</script>

<style scoped>
.order-list {
  max-width: 600px;
  margin: auto;
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.title {
  text-align: center;
  font-size: 24px;
  margin-bottom: 20px;
}

.order-container {
  display: flex;
  flex-direction: column;
}

.order-item {
  background-color: #fff;
  border-radius: 8px;
  margin-bottom: 15px;
  padding: 15px;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.1);
}

.order-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.order-status {
  color: #ff5722;
}

.order-details {
  display: flex;
  flex-wrap: wrap;
}

.order-product {
  display: flex; /* 使用flex布局 */
  align-items: center; /* 垂直居中 */
}

.product-image {
  width: 5rem;
  height: 4rem;
  margin-right: 10px; /* 图片和文字之间的间隔 */
}

.product-info {
  
  position: relative; /* 为绝对定位的子元素提供参照 */
}

.product-name {
  display: inline-block; /* 使元素为块级以支持宽度 */
  max-width: 200px; /* 根据需要设置最大宽度 */
  white-space: nowrap; /* 不换行 */
  overflow: hidden; /* 溢出隐藏 */
  text-overflow: ellipsis; /* 超出部分用省略号表示 */
  text-align: left; /* 文字左对齐 */
  margin-right: 1.2rem;
  font-weight: bold;
  font-size: 1rem;
}

.div-count{
  display: flex; /* 使用Flexbox布局 */
  justify-content: space-between; /* 在两端分散内容 */
  align-items: center; /* 垂直居中对齐 */
  width: 100%; /* 确保宽度为100% */
  margin-top: 1rem;
}

.product-fenlei{
  /* margin-top: 100000rem; */
  text-align: left; /* 文字左对齐 */
  color: #716e6c;
  font-size: 0.8rem;
}

.product-count{
  margin-right:  0rem;
  font-size: 0.8rem;
  font-weight: bold;
}

.product-price {
  color: #ff5722;
  font-weight: bold;
  /* font-weight: bold; */
  font-size: 1rem;
  /* margin-right: 0rem; */
}

.order-footer {
  text-align: right;
}

.btn {
  background-color: #ff5722;
  color: #fff;
  border: none;
  padding: 10px 15px;
  border-radius: 5px;
  cursor: pointer;
  margin-top: 1rem;
}

.btn:hover {
  background-color: #e64a19;
}
</style>
